import {
  BriefcaseIcon as DashboardIcon,
  ChatBubbleBottomCenterIcon as QuestionIcon,
  InboxIcon as FormIcon,
  FunnelIcon as FunnelIcon,
  UserCircleIcon as SegmentIcon,
  GiftIcon as OfferIcon,
  PuzzlePieceIcon as WidgetIcon,
  WindowIcon as PersonalizationIcon,
  AtSymbolIcon as EmailIcon,
  BoltIcon as GoalIcon,
  PresentationChartLineIcon as TestingIcon,
  UserGroupIcon as LeadsIcon,
  RocketLaunchIcon as GrowthIcon,
  WrenchScrewdriverIcon as OptimizationIcon
} from '@heroicons/vue/24/outline'
import { PEOPLE_PAGES_PERMISSION } from '@/modules/visitors/peoplePagesAccess'

const QUESTION_ROUTES = [ROUTES.QUESTIONS, ROUTES.QUESTION, ROUTES.SURVEY_RESPONSES]

const useSidebarNavigation = () => {
  const route = useRoute()
  const { canAccess } = usePermissionStore()

  return computed(() => [
    {
      name: 'Dashboard',
      to: { name: ROUTES.DASHBOARD },
      icon: DashboardIcon
    },
    ...(canAccess(PEOPLE_PAGES_PERMISSION)
      ? [{
          name: 'People',
          to: { name: ROUTES.PEOPLE },
          icon: LeadsIcon
        }]
      : []),
    { name: 'Enrich', type: 'divider' },
    {
      name: 'Segments',
      to: { name: ROUTES.SEGMENTGROUPS },
      icon: SegmentIcon
    },
    {
      name: 'Questions',
      to: { name: ROUTES.QUESTIONS },
      icon: QuestionIcon,
      children: QUESTION_ROUTES.includes(route.name)
        ? [
            { name: 'Open-Ended Responses', to: { name: ROUTES.SURVEY_RESPONSES } }
          ]
        : []
    },
    { name: 'Convert', type: 'divider' },
    {
      name: 'Flows',
      to: { name: ROUTES.OFFERFUNNELS },
      icon: FunnelIcon
    },
    {
      name: 'Widgets',
      to: { name: ROUTES.WIDGETS },
      icon: WidgetIcon
    },
    {
      name: 'Forms',
      to: { name: ROUTES.FORMS },
      icon: FormIcon
    },
    {
      name: 'Offers',
      to: { name: ROUTES.OFFERS },
      icon: OfferIcon
    },
    { name: 'Personalize', type: 'divider' },
    {
      name: 'Emails',
      to: { name: ROUTES.EMAILS },
      icon: EmailIcon,
      requiredFeature: 'personalized_emails'
    },
    {
      name: 'Campaigns',
      to: { name: ROUTES.CAMPAIGNS },
      icon: PersonalizationIcon,
      requiredFeature: 'campaigns'
    },
    {
      name: 'Conversion Goals',
      to: { name: ROUTES.GOALS },
      icon: GoalIcon,
      requiredFeature: 'goals'
    },
    { name: 'Optimize', type: 'divider' },
    {
      name: 'Growth Ideas',
      to: { name: ROUTES.GROWTH_IDEAS },
      icon: GrowthIcon,
      requiredFeature: 'full_analytics'
    },
    {
      name: 'Optimizations',
      to: { name: ROUTES.OPTIMIZATIONS },
      icon: OptimizationIcon,
      requiredFeature: 'full_analytics'
    },
    {
      name: 'A/B Testing',
      to: { name: ROUTES.SPLIT_TESTS },
      icon: TestingIcon,
      requiredFeature: 'split_testing'
    }
  ])
}

const generateUserNavigation = () => {
  const router = useRouter()
  const route = useRoute()
  const authStore = useAuthStore()
  const { user } = storeToRefs(authStore)

  const items = [
    {
      name: 'Your profile',
      action: () => {
        router.push({ name: ROUTES.PROFILE_PERSONAL })
      }
    },
    {
      name: 'Projects',
      action: () => router.push({ name: ROUTES.PROFILE_PROJECTS })
    }
  ]

  // Add Agency menu item only for agency users
  if (user.value?.is_agency) {
    items.push({
      name: 'Agency',
      action: () => router.push({ name: ROUTES.PROFILE_AGENCY_CLIENTS })
    })
  }

  items.push(
    {
      name: 'Billing',
      action: () => router.push({ name: ROUTES.PROFILE_BILLING })
    },
    { name: 'Sign out', action: () => (window.location.href = '/logout') }
  )

  return items
}

export { useSidebarNavigation, generateUserNavigation }
